/**
 * @desc 获取视图
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(params: API.ucenter.sysUserTableau.getTableauView.Params, options?: any) {
  return updateResponse(
    http(URL + `/sysUserTableau/getTableauView`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
